/* OllieTot Bloom theme behavior.
   Scroll reveals, sticky-nav inversion, and a cart drawer driven by the
   Cart AJAX API + Section Rendering API (section id: cart-drawer). */
(function () {
  "use strict";

  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Reveal sweep (geometry, not IntersectionObserver) ---------- */
  function sweep() {
    var limit = reduced ? Infinity : window.innerHeight * 0.94;
    var nodes = document.querySelectorAll(".ot-reveal:not(.is-in)");
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getBoundingClientRect().top < limit) nodes[i].classList.add("is-in");
    }
  }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sweep(); });
  }
  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("hashchange", schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });

  /* ---------- Sticky nav inversion ---------- */
  var header = document.getElementById("site-header");
  var logo = document.getElementById("brand-logo");
  var navOn = false;
  function navFlip() {
    if (!header) return;
    var on = window.scrollY > 24;
    if (on === navOn) return;
    navOn = on;
    header.classList.toggle("ot-inverse", on);
    if (logo && logo.dataset.srcInk && logo.dataset.srcCream) {
      logo.src = on ? logo.dataset.srcCream : logo.dataset.srcInk;
    }
  }
  // The header is sticky, so its height is spent on every screenful. Once the
  // reader is clearly moving through the page it gives some of that back.
  var navCompact = false;
  function navShrink() {
    if (!header) return;
    var on = window.scrollY > 220;
    if (on === navCompact) return;
    navCompact = on;
    header.classList.toggle("is-compact", on);
  }
  window.addEventListener("scroll", function () { navFlip(); navShrink(); }, { passive: true });

  /* ---------- Mobile menu ----------------------------------------------
     Below 640px the link row is display:none and, until now, nothing took
     its place — so most of the audience had no route to FAQ, shipping or
     care except the footer. */
  (function () {
    var toggle = document.querySelector("[data-nav-toggle]");
    var panel = document.querySelector("[data-nav-panel]");
    if (!toggle || !panel) return;

    function setOpen(open) {
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) {
        panel.hidden = false;
        // Next frame, so the max-height transition has a start value.
        requestAnimationFrame(function () { panel.classList.add("is-open"); });
      } else {
        panel.classList.remove("is-open");
        var done = function () { if (!panel.classList.contains("is-open")) panel.hidden = true; };
        if (reduced) done();
        else setTimeout(done, 320);
      }
    }

    toggle.addEventListener("click", function () {
      setOpen(toggle.getAttribute("aria-expanded") !== "true");
    });
    // A tap outside, Escape, or following a link all close it.
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
        setOpen(false);
        toggle.focus();
      }
    });
    document.addEventListener("click", function (e) {
      if (toggle.getAttribute("aria-expanded") !== "true") return;
      if (e.target.closest("[data-nav-panel]")) {
        if (e.target.closest("a")) setOpen(false);
        return;
      }
      if (!e.target.closest("[data-nav-toggle]")) setOpen(false);
    });
  })();

  /* ---------- In-page anchors -------------------------------------------
     "Shop the Purse" now lands on the buy box further down this page instead
     of loading a PDP. Two things that costs us if left to the browser: the
     sticky header covers the heading (scroll-margin-top in the CSS handles
     that), and a hash jump moves the viewport without moving focus, so a
     keyboard or screen-reader user is left where they started. */
  document.addEventListener("click", function (e) {
    var link = e.target.closest('a[href*="#"]');
    if (!link || link.hasAttribute("data-open-bag")) return;
    var url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname || !url.hash) return;
    var target = document.getElementById(url.hash.slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
    history.pushState(null, "", url.hash);
    if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
    target.focus({ preventScroll: true });
  });

  /* ---------- Money ---------- */
  function money(cents) {
    var n = cents / 100;
    return "$" + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  /* ---------- Analytics (no-op when ollietot-analytics.js is absent) ---------- */
  function ota(method) {
    var a = window.OllieTotAnalytics;
    if (a && typeof a[method] === "function") {
      a[method].apply(a, Array.prototype.slice.call(arguments, 1));
    }
  }

  /* ---------- Cart drawer ---------- */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function drawerEl() { return document.getElementById("bag-drawer"); }
  function scrimEl() { return document.getElementById("bag-scrim"); }

  function setBagOpen(open) {
    var drawer = drawerEl(), scrim = scrimEl();
    if (!drawer) return;
    if (open && !drawer.classList.contains("is-open")) ota("trackCartView");
    document.body.style.overflow = open ? "hidden" : "";
    document.body.classList.toggle("bag-open", open);
    drawer.classList.toggle("is-open", open);
    if (scrim) scrim.classList.toggle("is-open", open);
    drawer.dataset.open = open ? "true" : "false";
  }
  function isOpen() {
    var drawer = drawerEl();
    return !!drawer && drawer.classList.contains("is-open");
  }

  // True when the fresh render has the same cart lines (same products and
  // variants, same order) as the mounted drawer — i.e. only quantities,
  // totals, or footer notes changed.
  function sameLineup(freshDrawer, drawer) {
    var fresh = freshDrawer.querySelectorAll(".bag-line");
    var cur = drawer.querySelectorAll(".bag-line");
    if (!fresh.length || fresh.length !== cur.length) return false;
    for (var i = 0; i < fresh.length; i++) {
      var f = fresh[i].querySelector("[data-cart-dec]");
      var c = cur[i].querySelector("[data-cart-dec]");
      if (!f || !c || f.getAttribute("data-analytics-id") !== c.getAttribute("data-analytics-id")) return false;
    }
    return true;
  }

  function patchDrawer(freshDrawer, drawer) {
    var fresh = freshDrawer.querySelectorAll(".bag-line");
    var cur = drawer.querySelectorAll(".bag-line");
    for (var i = 0; i < fresh.length; i++) {
      ["[data-cart-dec]", "[data-cart-inc]", "[data-cart-remove]"].forEach(function (sel) {
        var fb = fresh[i].querySelector(sel), cb = cur[i].querySelector(sel);
        if (fb && cb) {
          cb.setAttribute("data-line", fb.getAttribute("data-line"));
          if (fb.hasAttribute("data-qty")) cb.setAttribute("data-qty", fb.getAttribute("data-qty"));
        }
      });
      var fq = fresh[i].querySelector(".stepper .qty"), cq = cur[i].querySelector(".stepper .qty");
      if (fq && cq) cq.textContent = fq.textContent;
      var ft = fresh[i].querySelector(".bag-line-total"), ct = cur[i].querySelector(".bag-line-total");
      if (ft && ct) ct.textContent = ft.textContent;
    }
    // The footer (subtotal, savings, nudges) has no images — swap it whole so
    // rows that appear/disappear with quantity are handled.
    var ff = freshDrawer.querySelector(".bag-foot"), cf = drawer.querySelector(".bag-foot");
    if (ff && cf) cf.innerHTML = ff.innerHTML;
  }

  function applyDrawerDoc(doc, openAfter) {
    var container = document.getElementById("CartDrawerContainer");
    if (!container) return;
    var freshDrawer = doc.getElementById("bag-drawer");
    var drawer = drawerEl();
    var wasOpen = isOpen() || openAfter;
    if (freshDrawer && drawer) {
      if (sameLineup(freshDrawer, drawer)) {
        // Quantity-only change: patch text and data attributes in place.
        // Rebuilding the lines recreates their <img> elements, which can
        // blank for a frame — the residual flicker.
        patchDrawer(freshDrawer, drawer);
      } else {
        // Lines added/removed (or empty <-> full): the structure really
        // changed, so swap the drawer's contents. Only the contents —
        // replacing the whole container unmounts the open <aside> and
        // its is-open class, closing/reopening the panel.
        drawer.innerHTML = freshDrawer.innerHTML;
      }
    } else {
      var fresh = doc.getElementById("CartDrawerContainer");
      if (fresh) container.innerHTML = fresh.innerHTML;
    }
    var count = doc.querySelector("[data-cart-count]");
    if (count) {
      var value = count.getAttribute("data-cart-count");
      document.querySelectorAll("[data-bag-count]").forEach(function (n) {
        n.textContent = value;
      });
      var localRoot = container.querySelector("[data-cart-count]");
      if (localRoot) localRoot.setAttribute("data-cart-count", value);
    }
    setBagOpen(!!wasOpen);
  }

  // Cart mutation responses can carry the re-rendered drawer section, saving
  // a second round trip; this applies one if present and reports success.
  function applyDrawerSections(data, openAfter) {
    var html = data && data.sections && data.sections["cart-drawer"];
    if (!html) return false;
    applyDrawerDoc(new DOMParser().parseFromString(html, "text/html"), openAfter);
    return true;
  }

  function refreshDrawer(openAfter) {
    var container = document.getElementById("CartDrawerContainer");
    if (!container) return Promise.resolve();
    container.classList.add("drawer-loading");
    return fetch(root + "?section_id=cart-drawer")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        applyDrawerDoc(new DOMParser().parseFromString(html, "text/html"), openAfter);
        container.classList.remove("drawer-loading");
      })
      .catch(function () { container.classList.remove("drawer-loading"); });
  }

  // Steppers stay clickable during a request (feedback is optimistic), so
  // responses can arrive out of order; only the newest one may touch the DOM.
  var changeSeq = 0;
  function changeLine(line, quantity) {
    var seq = ++changeSeq;
    return fetch(root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity, sections: "cart-drawer" })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (seq !== changeSeq) return;
        if (!applyDrawerSections(data, true)) return refreshDrawer(true);
      })
      .catch(function () {
        if (seq === changeSeq) return refreshDrawer(true);
      });
  }

  function cartUpdateFrom(t, action, newQty) {
    ota("trackCartUpdate", action, t.dataset.itemId, t.dataset.itemName,
      +t.dataset.itemPrice / 100 || undefined, newQty);
  }

  // Mirror the money filter's style: keep decimals only if the rendered
  // total had them (the server render corrects any mismatch moments later).
  function fmtMoney(cents, like) {
    var v = cents / 100;
    var whole = v % 1 === 0 && (!like || like.indexOf(".") === -1);
    return "$" + (whole ? String(v) : v.toFixed(2));
  }

  // Instant feedback for a stepper/remove tap: update the visible quantity,
  // line total, and bag count now; subtotal and discounts wait for the
  // server's rendered section, which reconciles everything.
  function optimisticStep(t, newQty) {
    var line = t.closest(".bag-line");
    if (!line) return;
    var decBtn = line.querySelector("[data-cart-dec]");
    var oldQty = +t.dataset.qty || (decBtn && +decBtn.dataset.qty) || 0;
    if (newQty <= 0) {
      line.style.display = "none";
    } else {
      var q = line.querySelector(".stepper .qty");
      if (q) q.textContent = newQty;
      line.querySelectorAll("[data-cart-dec], [data-cart-inc]").forEach(function (b) {
        b.setAttribute("data-qty", newQty);
      });
      var total = line.querySelector(".bag-line-total");
      var price = +t.dataset.itemPrice;
      if (total && price) total.textContent = fmtMoney(price * newQty, total.textContent);
    }
    bumpBagCount(newQty - oldQty);
  }

  function bumpBagCount(delta) {
    document.querySelectorAll("[data-bag-count]").forEach(function (n) {
      n.textContent = Math.max(0, (+n.textContent || 0) + delta);
    });
  }

  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-open-bag], [data-close-bag], [data-cart-dec], [data-cart-inc], [data-cart-remove]");
    if (!t) return;
    if (t.hasAttribute("data-open-bag")) { e.preventDefault(); setBagOpen(true); }
    else if (t.hasAttribute("data-close-bag")) { setBagOpen(false); }
    else if (t.hasAttribute("data-cart-dec")) {
      e.preventDefault();
      var decTo = +t.dataset.qty - 1;
      cartUpdateFrom(t, decTo === 0 ? "remove" : "decrease", decTo);
      optimisticStep(t, decTo);
      changeLine(+t.dataset.line, decTo);
    } else if (t.hasAttribute("data-cart-inc")) {
      e.preventDefault();
      var incTo = +t.dataset.qty + 1;
      cartUpdateFrom(t, "increase", incTo);
      optimisticStep(t, incTo);
      changeLine(+t.dataset.line, incTo);
    } else if (t.hasAttribute("data-cart-remove")) {
      e.preventDefault();
      cartUpdateFrom(t, "remove", 0);
      optimisticStep(t, 0);
      changeLine(+t.dataset.line, 0);
    }
  });

  // Email capture: log the signup (Shopify saves the customer; this records
  // the conversion in our own analytics before the form navigates away)
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (form.classList && form.classList.contains("capture-form")) {
      var input = form.querySelector('input[name="contact[email]"]');
      if (input && input.value) ota("trackEmailSignup", input.value, "email-capture");
    }
  }, true);
  window.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setBagOpen(false);
  });

  // Checkout buttons submit a form that navigates away. The old comment here
  // claimed a keepalive fetch made the event survive that; the analytics
  // client's own notes say the opposite, and keepalive fetch is exactly what
  // the in-app WKWebView drops when it is torn down mid-navigation.
  // trackCheckoutStart now flushes over sendBeacon, and debounces its own
  // burst, so a double-tap here is harmless — see ollietot-analytics.js.
  document.addEventListener("click", function (e) {
    if (e.target.closest('button[name="checkout"]')) ota("trackCheckoutStart");
  });

  /* ---------- Product forms (buy box + PDP) ---------- */
  document.querySelectorAll("[data-product-form]").forEach(function (wrap) {
    var form = wrap.querySelector("form");
    if (!form) return;
    var variantInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var qtyLabel = wrap.querySelector("[data-qty-label]");
    var addBtn = wrap.querySelector("[data-add-btn]");
    var colorLabel = wrap.querySelector("[data-color-label]");
    var addedTimer = null;
    // Opt-OUT of the automatic $10-off-2 / $20-off-3 button maths. Absent —
    // which is every buy box on the live site — the ladder applies exactly as
    // before. The Labor Day cells set data-ladder="off" because a discount
    // code cancels both automatics (their combinesWith.orderDiscounts and
    // .productDiscounts are false), so quoting a bundle saving there would
    // promise a price Shopify will not honour at checkout.
    var noLadder = wrap.getAttribute("data-ladder") === "off";

    function unitPrice() {
      var active = wrap.querySelector(".swatch.is-active");
      return active ? +active.dataset.price : +(addBtn ? addBtn.dataset.price : 0);
    }
    function updateButton() {
      if (!addBtn || addBtn.classList.contains("is-added")) return;
      var qty = qtyInput ? +qtyInput.value : 1;
      var gross = unitPrice() * qty;
      var off = noLadder ? 0 : (qty >= 3 ? 2000 : qty === 2 ? 1000 : 0);
      if (off > 0) {
        addBtn.textContent = "";
        addBtn.appendChild(document.createTextNode(addBtn.dataset.label + " — " + money(gross - off) + " "));
        var was = document.createElement("s");
        was.textContent = money(gross);
        addBtn.appendChild(was);
      } else {
        addBtn.textContent = addBtn.dataset.label + " — " + money(gross);
      }
    }
    function showRender(id) {
      wrap.querySelectorAll("[data-variant-render]").forEach(function (r) {
        r.classList.toggle("is-active", r.getAttribute("data-variant-render") === String(id));
      });
    }
    function clearPhoto() {
      var view = wrap.querySelector(".shop-photo-view");
      var thumbsWrap = wrap.querySelector(".shop-thumbs");
      if (view) { view.classList.remove("is-active"); view.style.backgroundImage = "none"; }
      if (thumbsWrap) thumbsWrap.classList.remove("has-active");
      wrap.querySelectorAll(".shop-thumb.is-active").forEach(function (b) { b.classList.remove("is-active"); });
    }

    wrap.querySelectorAll(".swatch").forEach(function (b) {
      b.addEventListener("click", function () {
        wrap.querySelectorAll(".swatch").forEach(function (s) { s.classList.remove("is-active"); });
        b.classList.add("is-active");
        if (variantInput) variantInput.value = b.dataset.variantId;
        if (colorLabel) colorLabel.textContent = b.dataset.name;
        clearPhoto();
        showRender(b.dataset.variantId);
        updateButton();
      });
    });

    // Preload the gallery so switching photos never flashes the base
    // render while the browser fetches the next image.
    wrap.querySelectorAll(".shop-thumb").forEach(function (b) {
      var i = new Image();
      i.src = b.dataset.photo;
    });

    var photoToken = 0;
    wrap.querySelectorAll(".shop-thumb").forEach(function (b) {
      b.addEventListener("click", function () {
        var view = wrap.querySelector(".shop-photo-view");
        var thumbsWrap = wrap.querySelector(".shop-thumbs");
        var active = b.classList.contains("is-active");
        var token = ++photoToken;
        if (active || !view) { clearPhoto(); return; }
        // Swap only once the image is decoded; the previous photo (or the
        // render) stays on screen until then, so there is no flash.
        var apply = function () {
          if (token !== photoToken) return;
          wrap.querySelectorAll(".shop-thumb.is-active").forEach(function (t) { t.classList.remove("is-active"); });
          view.style.backgroundImage = "url(" + b.dataset.photo + ")";
          view.classList.add("is-active");
          b.classList.add("is-active");
          if (thumbsWrap) thumbsWrap.classList.add("has-active");
        };
        var probe = new Image();
        probe.onload = apply;
        probe.src = b.dataset.photo;
        if (probe.complete) apply();
      });
    });
    var photoView = wrap.querySelector(".shop-photo-view");
    if (photoView) photoView.addEventListener("click", clearPhoto);

    wrap.querySelectorAll("[data-qty-dec], [data-qty-inc]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (!qtyInput) return;
        var q = +qtyInput.value + (b.hasAttribute("data-qty-inc") ? 1 : -1);
        qtyInput.value = Math.max(1, q);
        if (qtyLabel) qtyLabel.textContent = qtyInput.value;
        updateButton();
      });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      // Open the drawer now — the slide-in animation covers the request, and
      // the new line appears mid-slide when the rendered section arrives.
      setBagOpen(true);
      var addQty = qtyInput ? +qtyInput.value || 1 : 1;
      bumpBagCount(addQty);
      var data = new FormData(form);
      data.append("sections", "cart-drawer");
      fetch(root + "cart/add.js", { method: "POST", body: data })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function (resp) {
          var qty = qtyInput ? +qtyInput.value : 1;
          ota(
            "trackAddToCart",
            wrap.dataset.productId || (variantInput && variantInput.value),
            wrap.dataset.productName,
            unitPrice() / 100,
            qty
          );
          if (addBtn) {
            var active = wrap.querySelector(".swatch.is-active");
            addBtn.classList.add("is-added");
            addBtn.textContent = active ? "Added — " + active.dataset.name + " ✓" : "Added ✓";
            clearTimeout(addedTimer);
            addedTimer = setTimeout(function () {
              addBtn.classList.remove("is-added");
              updateButton();
            }, 1800);
          }
          if (!applyDrawerSections(resp, true)) return refreshDrawer(true);
        })
        .catch(function () {
          bumpBagCount(-addQty);
          if (addBtn) addBtn.textContent = "Sold out";
        });
    });

    updateButton();
  });

  /* ---------- Simple add buttons (gift cards, cross-sells) ---------- */
  document.querySelectorAll("[data-quick-add]").forEach(function (btn) {
    var addedTimer = null;
    var label = btn.textContent;
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      setBagOpen(true);
      bumpBagCount(1);
      fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: +btn.dataset.quickAdd, quantity: 1, sections: "cart-drawer" })
      })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function (item) {
          ota("trackAddToCart", String(item.product_id || btn.dataset.quickAdd),
            item.product_title || label, (item.price || 0) / 100, 1);
          btn.classList.add("is-added");
          btn.textContent = "Added ✓";
          clearTimeout(addedTimer);
          addedTimer = setTimeout(function () {
            btn.classList.remove("is-added");
            btn.textContent = label;
          }, 1800);
          if (!applyDrawerSections(item, true)) return refreshDrawer(true);
        })
        .catch(function () { bumpBagCount(-1); btn.textContent = "Sold out"; });
    });
  });

  /* ---------- Drift rails: photos and quotes ---------------------------
     One engine for both. Each row translates left at a steady px/s until the
     reader takes over, then hands back momentum-free manual control. The
     track's children are duplicated once so the loop is seamless; drift wraps
     at half the scroll width, which is exactly one copy.

     Three things this owes the reader. WCAG 2.2.2 (Level A) wants motion
     lasting over five seconds to be stoppable, so every rail ships a pause
     control. prefers-reduced-motion starts paused rather than merely slower.
     And a rail that is off screen does not animate at all.

     It also owes us data. Arrow taps used to be 43% of every click on the
     site — our single strongest engagement signal — and removing the arrows
     would have deleted it. Drag distance and per-rail dwell are reported in
     their place. */
  (function () {
    var rails = document.querySelectorAll("[data-drift-rail]");
    if (!rails.length) return;
    var reducedQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    rails.forEach(function (rail) {
      var tracks = Array.prototype.slice.call(rail.querySelectorAll("[data-drift-track]"));
      if (!tracks.length) return;
      var speed = parseFloat(rail.dataset.driftSpeed);
      if (isNaN(speed)) speed = 22;
      var analyticsId = rail.dataset.analyticsId || "drift-rail";

      // Duplicate each row once so the wrap is invisible. Clones are hidden
      // from assistive tech and from the impression observer, which would
      // otherwise count every photo twice.
      tracks.forEach(function (track) {
        var originals = Array.prototype.slice.call(track.children);
        originals.forEach(function (node) {
          var clone = node.cloneNode(true);
          clone.setAttribute("aria-hidden", "true");
          // The loop copy must not be counted. Without this marker the
          // analytics client's visibility observer sees each rail photo twice
          // and every impression number for the rails doubles.
          clone.setAttribute("data-drift-clone", "");
          clone.querySelectorAll("img").forEach(function (i) {
            i.setAttribute("data-drift-clone", "");
          });
          clone.removeAttribute("data-review-id");
          clone.removeAttribute("data-analytics-id");
          clone.querySelectorAll("[data-analytics-id], [id]").forEach(function (n) {
            n.removeAttribute("data-analytics-id");
            n.removeAttribute("id");
          });
          clone.querySelectorAll("button").forEach(function (b) { b.tabIndex = -1; });
          if (clone.tagName === "BUTTON") clone.tabIndex = -1;
          track.appendChild(clone);
        });
        track.dataset.offset = "0";
        // Rows alternate direction so the two photo rows do not read as one
        // block sliding sideways.
        track.dataset.dir = (+track.dataset.driftTrack % 2 === 0) ? "-1" : "1";
      });

      var paused = reducedQuery.matches;   // reduced motion: start at rest
      var userHeld = false;
      var onScreen = false;
      var last = 0;

      function halfWidth(track) { return track.scrollWidth / 2; }

      function apply(track) {
        track.style.transform = "translate3d(" + (-(+track.dataset.offset)) + "px,0,0)";
      }

      function step(now) {
        if (!last) last = now;
        var dt = Math.min((now - last) / 1000, 0.05);
        last = now;
        if (!paused && !userHeld && onScreen && speed > 0) {
          tracks.forEach(function (track) {
            var half = halfWidth(track);
            if (!half) return;
            var next = +track.dataset.offset + speed * dt * (+track.dataset.dir);
            // Wrap in both directions so either drift sense loops cleanly.
            if (next >= half) next -= half;
            if (next < 0) next += half;
            track.dataset.offset = next;
            apply(track);
          });
        }
        raf = requestAnimationFrame(step);
      }
      var raf = requestAnimationFrame(step);

      // Off-screen rails do not animate.
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { onScreen = e.isIntersecting; });
        }, { threshold: 0 }).observe(rail);
      } else {
        onScreen = true;
      }

      /* ---- pause control ---- */
      var pauseBtn = document.querySelector('[data-drift-pause="' + rail.id + '"]');
      function setPaused(next) {
        paused = next;
        if (!pauseBtn) return;
        pauseBtn.setAttribute("aria-pressed", paused ? "true" : "false");
        var label = pauseBtn.querySelector("[data-drift-pause-label]");
        if (label) label.textContent = paused ? "Play" : "Pause";
      }
      if (pauseBtn) {
        setPaused(paused);
        pauseBtn.addEventListener("click", function () { setPaused(!paused); });
      }

      /* ---- drag, and the engagement signal the arrows used to give ---- */
      var down = false, startX = 0, startOffsets = [], moved = 0, dragTotal = 0;

      rail.addEventListener("pointerdown", function (e) {
        if (e.target.closest("button")) return;   // Read more stays clickable
        down = true; userHeld = true; moved = 0;
        startX = e.clientX;
        startOffsets = tracks.map(function (t) { return +t.dataset.offset; });
        // Capture keeps the drag alive if the pointer leaves the rail.
        // Throws for a pointer id the element never received (synthetic
        // events, some pen/touch edge cases) and must not break the drag.
        try { rail.setPointerCapture(e.pointerId); } catch (err) {}
      });
      rail.addEventListener("pointermove", function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) rail.classList.add("is-dragging");
        moved = Math.abs(dx);
        tracks.forEach(function (track, i) {
          var half = halfWidth(track);
          if (!half) return;
          var next = (startOffsets[i] - dx) % half;
          if (next < 0) next += half;
          track.dataset.offset = next;
          apply(track);
        });
      });
      function release() {
        if (!down) return;
        down = false; userHeld = false;
        rail.classList.remove("is-dragging");
        dragTotal += moved;
      }
      rail.addEventListener("pointerup", release);
      rail.addEventListener("pointercancel", release);

      // Keyboard: the rail is focusable, so arrows must move it.
      rail.addEventListener("keydown", function (e) {
        if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
        e.preventDefault();
        var dx = e.key === "ArrowRight" ? 120 : -120;
        tracks.forEach(function (track) {
          var half = halfWidth(track);
          if (!half) return;
          var next = (+track.dataset.offset + dx) % half;
          if (next < 0) next += half;
          track.dataset.offset = next;
          apply(track);
        });
        dragTotal += Math.abs(dx);
      });

      // Report when the rail leaves the viewport, not on pagehide. The
      // analytics client registers its own pagehide flush first (it is the
      // earlier <script defer>), so anything queued from a later pagehide
      // listener is queued after the last batch has already gone and is
      // simply lost. A rail scrolling out of view is the honest end of an
      // episode anyway, and it rides the normal batch.
      var enteredAt = 0, dwell = 0;
      function reportRail() {
        if (enteredAt) { dwell += Date.now() - enteredAt; enteredAt = 0; }
        if (dwell < 500 && !dragTotal) return;
        ota("trackRailEngagement", analyticsId, Math.round(dwell), Math.round(dragTotal));
        dwell = 0; dragTotal = 0;
      }
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { enteredAt = Date.now(); }
            else if (enteredAt) { dwell += Date.now() - enteredAt; enteredAt = 0; reportRail(); }
          });
        }, { threshold: 0.4 }).observe(rail);
      }
      // Best effort for a page that dies with the rail still on screen.
      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") reportRail();
      });
    });

    /* ---- Read more: full quote in place, and the rail holds still ---- */
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-quote-more]");
      if (!btn) return;
      var card = btn.closest(".quote-card");
      if (!card) return;
      var short = card.querySelector("[data-quote-short]");
      var full = card.querySelector("[data-quote-full]");
      if (!short || !full) return;
      var open = full.hidden;
      full.hidden = !open;
      short.hidden = open;
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      btn.textContent = open ? "Show less" : "Read more";
      // Expanding is a deliberate act of reading; stop the rail moving under
      // the reader rather than making them chase the text.
      var railEl = card.closest("[data-drift-rail]");
      var pauseBtn = railEl && document.querySelector('[data-drift-pause="' + railEl.id + '"]');
      if (open && pauseBtn && pauseBtn.getAttribute("aria-pressed") !== "true") pauseBtn.click();
    });
  })();


  /* ---------- Sticky buy bar (mobile) ----------------------------------
     The bar owns no product data. It binds to whichever buy box is nearest
     the viewport, mirrors that box's name, colour and price, and delegates
     Add straight to that box's form — so the existing AJAX add, the cart
     drawer and the add_to_cart event all run exactly as they do inline.

     It stays hidden while the hero is on screen (nothing to buy yet), while
     the cart drawer is open, and while the bound box's own Add button is
     visible, so the page never shows two identical calls to action at once. */
  (function () {
    var bar = document.querySelector("[data-buy-bar]");
    var boxes = Array.prototype.slice.call(document.querySelectorAll("[data-product-form]"));
    if (!bar || !boxes.length) return;

    var nameEl = bar.querySelector("[data-buy-bar-name]");
    var metaEl = bar.querySelector("[data-buy-bar-meta]");
    var addEl = bar.querySelector("[data-buy-bar-add]");
    var bound = null;
    var addedTimer = null;
    var shown = false;

    function priceOf(box) {
      var active = box.querySelector(".swatch.is-active");
      var btn = box.querySelector("[data-add-btn]");
      return +(active ? active.dataset.price : btn && btn.dataset.price) || 0;
    }
    function colourOf(box) {
      var active = box.querySelector(".swatch.is-active");
      return active ? active.dataset.name : "";
    }
    function soldOut(box) {
      var btn = box.querySelector("[data-add-btn]");
      return !btn || btn.disabled;
    }

    // The box whose midpoint is nearest the middle of the viewport, which is
    // the one the reader is looking at on a single-column phone layout.
    function nearestBox() {
      var mid = window.innerHeight / 2, best = null, bestDist = Infinity;
      boxes.forEach(function (box) {
        var r = box.getBoundingClientRect();
        var d = Math.abs((r.top + r.bottom) / 2 - mid);
        if (d < bestDist) { bestDist = d; best = box; }
      });
      return best;
    }

    // Two optional per-box overrides, both absent on every buy box the theme
    // ships today, so the homepage and both PDPs render exactly as before:
    //   data-buy-bar-note   appended to the meta line after the price
    //   data-buy-bar-label  replaces the button's own label
    // They exist because a preorder product must not be able to surface a
    // bare price and an "Add to cart" button in the sticky bar while its own
    // buy box (which does say "Preorder" and "Ships October 1") is off
    // screen. Do NOT solve that by editing data-product-name: that field is
    // sent to add_to_cart and product_view.
    function render(box) {
      if (!box) return;
      bound = box;
      if (nameEl) nameEl.textContent = box.dataset.productName || "";
      if (metaEl) {
        var colour = colourOf(box);
        var price = priceOf(box);
        var note = box.dataset.buyBarNote || "";
        metaEl.textContent = (colour ? colour + " · " : "") +
          (price ? money(price) : "") +
          (note ? (price || colour ? " · " : "") + note : "");
      }
      if (addEl && !addEl.classList.contains("is-added")) {
        addEl.disabled = soldOut(box);
        addEl.textContent = soldOut(box)
          ? "Sold out"
          : box.dataset.buyBarLabel || addEl.dataset.label || "Add to cart";
      }
    }

    // Hidden while the bound box's own button is on screen — two identical
    // Add buttons a thumb apart is noise, not emphasis.
    function ownButtonVisible(box) {
      var btn = box && box.querySelector("[data-add-btn]");
      if (!btn) return false;
      var r = btn.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }

    // Appears once the hero has gone by — before that there is nothing to buy
    // yet and the bar would just cover the opening image.
    var heroEl = document.querySelector(".hero");
    function revealPoint() {
      return heroEl ? Math.max(heroEl.offsetHeight - 80, 120) : window.innerHeight * 0.6;
    }

    function update() {
      var box = nearestBox();
      if (box && box !== bound) render(box);
      var want = window.scrollY > revealPoint() && !!bound && !ownButtonVisible(bound)
        && !document.body.classList.contains("bag-open");
      if (want === shown) return;
      shown = want;
      bar.classList.toggle("is-visible", want);
      bar.setAttribute("aria-hidden", want ? "false" : "true");
    }

    if (addEl) {
      addEl.dataset.label = addEl.textContent.trim();
      addEl.addEventListener("click", function () {
        if (!bound || addEl.disabled) return;
        var form = bound.querySelector("form");
        if (!form) return;
        // Delegate to the inline form so add, drawer and analytics are shared.
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
        addEl.classList.add("is-added");
        addEl.textContent = "Added ✓";
        clearTimeout(addedTimer);
        addedTimer = setTimeout(function () {
          addEl.classList.remove("is-added");
          render(bound);
        }, 1800);
      });
    }

    // Colour changes on a buy box have to reach the bar's price and swatch name.
    boxes.forEach(function (box) {
      box.addEventListener("click", function (e) {
        if (e.target.closest(".swatch") && box === bound) render(box);
      });
    });

    // Only now is the bar wired up; until this point it stays out of the
    // accessibility tree so a no-JS page never exposes a dead button.
    bar.hidden = false;
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    render(nearestBox());
    update();
  })();

  navFlip();
  navShrink();
  sweep();
})();
